const Reset = () => {
    return (
        <button type="button" class="btn btn-lg btn-danger pull-left btn-xs-block dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
            <i class="fa fa-times"></i> Reset... <span class="caret"></span>
        </button>
    );
}

export default Reset;